import { FC, useMemo } from 'react';
import { css } from '@emotion/react';
import { OnboardingTasksV2 } from '@frontend/api-onboarding-tasks';
import { useTranslation } from '@frontend/i18n';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { ScheduledAppointmentData } from '../../types';
import { getScheduledAppointmentList } from '../../utils';
import { AppointmentCard } from './appointment-card';

interface AppointmentCardListProps {
  moduleTasks: OnboardingTasksV2.Types.ModuleRow[];
}

export const AppointmentCardList: FC<AppointmentCardListProps> = ({ moduleTasks }) => {
  const { t } = useTranslation('onboardingDashboard');

  const scheduledAppointmentsList = useMemo<ScheduledAppointmentData[]>(() => {
    return getScheduledAppointmentList(moduleTasks);
  }, [moduleTasks]);

  if (!scheduledAppointmentsList.length) {
    return null;
  }
  return (
    <div css={styles.container}>
      <Text size='medium' color='light'>
        {t('Upcoming Dates')}
      </Text>

      <div css={styles.cardsList}>
        {scheduledAppointmentsList.map((appointment, index) => (
          <AppointmentCard key={index} {...appointment} />
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(1)};
    padding: ${theme.spacing(2, 0)};
    container-type: inline-size;
  `,
  cardsList: css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing(1)};
    flex-wrap: wrap;

    @container (max-width: ${breakpoints.small.max}px) {
      flex-wrap: nowrap;
      overflow-x: auto;
      padding-bottom: ${theme.spacing(1)};
    }
  `,
};
